import { render, staticRenderFns } from "./SDKList.vue?vue&type=template&id=476ac3cc&scoped=true&"
import script from "./SDKList.vue?vue&type=script&lang=js&"
export * from "./SDKList.vue?vue&type=script&lang=js&"
import style0 from "./SDKList.vue?vue&type=style&index=0&id=476ac3cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476ac3cc",
  null
  
)

export default component.exports